import { Inject, Injectable } from '@angular/core';
import { ZOP_UX_LAYOUT_LIB_CONFIG } from '../../const/zop-ux-layout.token';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';
import { ZopUxLayoutLibConfig } from './config.types';

@Injectable({ providedIn: 'root' })
export class ZopUxLayoutConfigService {
    private _config: BehaviorSubject<ZopUxLayoutLibConfig>;

    /**
     * Constructor
     */
    constructor(
        @Inject(ZOP_UX_LAYOUT_LIB_CONFIG) config: ZopUxLayoutLibConfig
    ) {
        // Private
        this._config = new BehaviorSubject(config);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: ZopUxLayoutLibConfig) {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value);

        // Execute the observable
        this._config.next(config);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<ZopUxLayoutLibConfig> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this.config);
    }
}
